<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="createForm.id?'修改代理商' :'新增代理商'"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          v-if="!convertId"
          label="代理商名称"
          prop="agentName"
        >
          <el-input v-model="createForm.agentName" />
        </el-form-item>
        <el-form-item
          v-if="!convertId"
          label="负责人名称"
          prop="chargePersonName"
        >
          <el-input v-model="createForm.chargePersonName" />
        </el-form-item>
        <el-form-item
          v-if="!convertId"
          label="负责人电话"
          prop="chargePersonPhone"
        >
          <el-input v-model="createForm.chargePersonPhone" />
        </el-form-item>
        <el-form-item
          v-if="!convertId"
          label="联系地址"
          prop="address"
        >
          <el-input v-model="createForm.address" />
        </el-form-item>
        <el-form-item
          v-if="!convertId"
          label="省市区"
          prop="provinceInfo"
        >
          <el-cascader
            v-model="createForm.provinceInfo"
            :props="cascaderProps"
            :options="province"
            @change="formatCity"
          />
        </el-form-item>
        <el-form-item
          v-if="!convertId"
          label="营业执照"
          prop="businessLicense"
        >
          <upload :file-list.sync="createForm.businessLicense" />
        </el-form-item>
        <el-form-item
          label="代理区域"
          prop="agentAreaInfoList"
        >
          <el-cascader
            v-model="createForm.agentAreaInfoList"
            :props="cascaderMultipleProps"
            :options="province"
            @change="formatMultipleCity"
          />
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            v-model="createForm.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'AgentDialog',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
    convertId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'sonList',
      },
      cascaderMultipleProps: {
        multiple: true,
        value: 'id',
        label: 'name',
        children: 'sonList',
      },
      cancelText: '取消',
      awardCouponList: [],
      createForm: {
        id: null,
        agentName: null,
        chargePersonPhone: '',
        chargePersonName: '',
        address: '',
        businessLicense: '',
        remark: '',
        agentAreaList: [],
        agentAreaInfoList: [],
        provinceInfo: '',
      },
      creatRules: {
        agentName: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' },
        ],
        chargePersonPhone: [
          {
            required: true, message: '请输入负责人电话', trigger: 'blur',
          },
        ],
        chargePersonName: [
          {
            required: true, message: '请输入负责人名称', trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['province']),
  },
  watch: {
    item: {
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            const {
              id,
              agentName,
              chargePersonPhone,
              chargePersonName,
              address,
              provinceId,
              cityId,
              areaId,
              remark,
              businessLicense,
              agentAreaList,
            } = val;
            const agentAreaInfoList = [];
            if (agentAreaList) {
              agentAreaList.forEach((item) => {
                const itemProvinceId = item.provinceId;
                const itemCityId = item.cityId;
                const itemAreaId = item.areaId;
                agentAreaInfoList.push([itemProvinceId, itemCityId, itemAreaId]);
              });
            }
            this.createForm = {
              id,
              agentName,
              chargePersonPhone,
              chargePersonName,
              address,
              agentAreaInfoList,
              provinceInfo: [provinceId, cityId, areaId],
              provinceId,
              cityId,
              areaId,
              remark,
              businessLicense,
              agentAreaList,
            };
          }
          this.createForm.id = null;
        });
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.$refs.createForm.clearValidate();
      this.$refs.createForm.resetFields();
      this.$emit('update:dialogVisible', false);
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          if (!this.convertId) {
            const data = await axClient.agent.agentUpsert(this.createForm);
            if (!data) return;
            if (this.createForm.id) {
              this.$message.success('修改代理商成功');
            } else {
              this.$message.success('新增代理商成功');
            }
          } else {
            const data = await axClient.agent.insertByAgency({
              agencyId: this.convertId,
              remark: this.createForm.remark,
              agentAreaList: this.createForm.agentAreaList,
            });
            if (!data) return;
            this.$message.success('机构转换代理商成功');
          }
          this.close();
          this.$emit('confirm');
        }
      });
    },
    // 处理省市区
    formatCity(item) {
      const [provinceId, cityId, areaId] = item;
      this.createForm = Object.assign(this.createForm, { provinceId, cityId, areaId });
    },
    // 处理省市区 多选
    formatMultipleCity(itemList) {
      if (itemList.length > 0) {
        const agentAreaList = [];
        itemList.forEach((item) => {
          const [provinceId, cityId, areaId] = item;
          agentAreaList.push({
            provinceId, cityId, areaId,
          });
        });
        this.createForm.agentAreaList = agentAreaList;
      } else {
        this.createForm.agentAreaList = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
}
</style>
